import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useFormStore } from '../stores/form';
export default function useNavigation() {
  var _useNuxtApp = useNuxtApp(),
    $gtm = _useNuxtApp.$gtm,
    $bus = _useNuxtApp.$bus;
  var router = useRouter();
  var store = useFormStore();
  var nextStep = function nextStep(routeName) {
    if (routeName.includes('lidmaatschap')) {
      $gtm.push({
        event: 'selected_membership',
        membership: _objectSpread({}, store.membershipType)
      });
      store.steps.membership = true;
      if (store.clubHasAddons && store.abTest) {
        router.push('/extra-opties');
        return;
      } else if (store.clubHasAddons) {
        router.push('/ab/extra-opties');
        return;
      }
      if (store.abTest) {
        router.push('/persoonlijke-gegevens');
        return;
      }
      router.push('/ab/persoonlijke-gegevens');
    } else if (routeName.includes('extra-opties')) {
      $bus.$emit('submitForm', 'extra-opties');
    } else if (routeName.includes('persoonlijke-gegevens')) {
      $bus.$emit('submitForm', 'persoonlijke-gegevens');
    } else if (routeName.includes('adresgegevens')) {
      $bus.$emit('submitForm', 'adresgegevens');
    }
  };
  var previousStep = function previousStep(routeName) {
    if (routeName.includes('extra-opties')) {
      store.steps.membership = false;
      if (store.abTest) {
        router.push('/lidmaatschap');
        return;
      }
      router.push('/ab/lidmaatschap');
      return;
    }
    if (routeName.includes('persoonlijke-gegevens')) {
      if (store.clubHasAddons && store.abTest) {
        router.push('/extra-opties');
        return;
      } else if (store.clubHasAddons) {
        router.push('/ab/extra-opties');
        return;
      }
      if (store.abTest) {
        router.push('/lidmaatschap');
        return;
      }
      router.push('/ab/lidmaatschap');
      return;
    }
    if (routeName.includes('betalingsgegevens')) {
      if (store.abTest) {
        router.push('/persoonlijke-gegevens');
        return;
      }
      router.push('/ab/persoonlijke-gegevens');
    }
  };
  return {
    nextStep: nextStep,
    previousStep: previousStep
  };
}